module.exports = __webpack_public_path__ + "0258af3c5b10aade68db5c353d20d449.svg";